import { render } from "./StaffTrackList.vue?vue&type=template&id=02dccdd2"
import script from "./StaffTrackList.vue?vue&type=script&lang=js"
export * from "./StaffTrackList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__